<template>
  <div>
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-container fluid class="fill-height">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" sm="12" md="12">
          <h1 class="page-title">Videos</h1>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col cols="12" sm="12" md="12">
          <search :loading="loading" name="Video" />
        </v-col>

        <v-col style="text-align: end" cols="12" sm="12" md="12">
          <v-btn
            color="btn-color"
            class="mt-3 mr-5"
            @click="showAddVideoDialog"
            :loading="loading"
          >
            <v-icon left> fas fa-plus </v-icon>
            Agregar video
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <files-table
            @menuClick="handleMenuActions($event)"
            :items="videos"
            :showView="true"
            :showEdit="true"
            :showDelete="true"
            :loading="loading"
            :headers="headers"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-if="addVideoDialog"
      persistent
      v-model="addVideoDialog"
      :max-width="selectedVideo ? '400px' : '1000px'"
    >
      <add-video
        :originalItem="selectedVideo"
        @success="videoUploaded"
        @cancel="
          addVideoDialog = false;
          selectedVideo = null;
        "
      />
    </v-dialog>

    <v-dialog
      hide-overlay
      fullscreen
      max-width="60%"
      v-if="viewVideoDialog"
      v-model="viewVideoDialog"
    >
      <view-file :url="selectedVideo.url" :type="selectedVideo.type" @cancel="viewVideoDialog = false" />
    </v-dialog>

    <v-dialog
      max-width="500px"
      v-if="deleteVideoDialog"
      v-model="deleteVideoDialog"
    >
      <delete-video
        ref="deleteComponent"
        :name="selectedVideo.name"
        @success="confirmDelete"
        @cancel="deleteVideoDialog = false"
      />
    </v-dialog>
  </div>
</template>
<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";
import addVideo from "./add-video";
import viewFile from "@/components/view-file";
import deleteVideo from "@/components/delete";
import filesTable from "@/components/files-table";

export default {
  name: "Videos",
  components: {
    addVideo,
    viewFile,
    deleteVideo,
    filesTable,
  },
  data() {
    return {
      videos: [],
      snackbarText: "",
      snackbar: false,
      loading: true,
      addVideoDialog: false,
      selectedVideo: null,
      viewVideoDialog: false,
      editVideoDialog: false,
      deleteVideoDialog: false,
      menuItems: [
        { title: "Ver", icon: "fas fa-eye" },
        { title: "Editar", icon: "fas fa-edit" },
        { title: "Eliminar", icon: "fas fa-trash" },
      ],
      headers: [
        {
          value: "image",
          width: "150px",
        },
        {
          text: "Nombre",
          value: "name",
          width: "150px",
        },

        {
          text: "Tamaño",
          value: "size",
          width: "150px",
        },
        {
          text: "Duración",
          value: "duration",
          width: "150px",
        },
        // {
        //   text: "Extensión",
        //   value: "extension",
        //   width: "150px",
        // },
        {
          text: "Fecha de creación",
          value: "createdAt",
          width: "200px",
        },
        {
          value: "options",
          sortable: false,
          align: "end",
          width : "200px"
        },
      ],
    };
  },

  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      anim.setSpeed(this.animationSpeed);
    },
    handleMenuActions(payload) {
      switch (payload.action) {
        case 0:
          this.showViewVideoDialog(payload.item);
          break;
        case 1:
          this.editVideo(payload.item);
          break;
        case 2:
          this.showDeleteDialog(payload.item);
          break;
      }
    },
    showAddVideoDialog() {
      this.selectedVideo = null;
      this.addVideoDialog = true;
    },
    showViewVideoDialog(item) {
      this.selectedVideo = item;
      this.viewVideoDialog = true;
    },
    editVideo(item) {
      this.selectedVideo = item;
      this.addVideoDialog = true;
    },

    showDeleteDialog(item) {
      this.selectedVideo = item;
      this.deleteVideoDialog = true;
    },
    async confirmDelete() {
      this.$refs.deleteComponent.loading = true;
      db.collection("files")
        .doc(this.selectedVideo[".key"])
        .delete()
        .then(async (response) => {
          await this.deleteFile();
          this.snackbarText = "Video borrado exitosamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
          this.deleteVideoDialog = false;
        })
        .catch((error) => {
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
        });
    },
    deleteFile() {
      return new Promise(async (resolve, reject) => {
        let groupId = this.$store.state.groupId;
        let storageRef = fb.app().storage("gs://beanage-files").ref();
        var desertRef = storageRef.child(
          `${groupId}/${this.selectedVideo[".key"]}/${this.selectedVideo.dataName}`
        );
        // var screenshotRef = storageRef.child(`${groupId}/${this.selectedVideo[".key"]}/file-screenshot.jpg`);
        // await screenshotRef.delete()
        desertRef
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch((error) => {
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
            this.$refs.deleteComponent.loading = false;
            reject(false);
          });
      });
    },
    videoUploaded(data) {
      this.addVideoDialog = false;
      this.selectedVideo = null;
      this.snackbarText = `Video ${
        data == "updated" ? "editado" : "agregado"
      } exitosamente.`;
      this.snackbar = true;
    },
  },
  mounted() {
    let groupId = this.$store.state.groupId;

    if (!groupId) return;

    db.collection("files")
      .where("groupId", "==", groupId)
      .where("type", "==", "video")
      .onSnapshot((response) => {
        this.videos = [];
        response.forEach((item) => {
          let video = item.data();
          video[".key"] = item.id;
          this.videos.push(video);
        });
        this.loading = false;
      });
  },
};
</script>

<style>
.v-dialog--fullscreen {
  border-radius: 0 !important;
  background-color: #000000e3;
}
</style>